<div class="container-customer-details">
  <div class="box-customer-details">
    <div>
      <div class="card-content">
        <div class="name">{{ salesManagerObj?.name }} (Sales Manager)</div>
        <div>
          <div class="phone">
            <up-icon name="local_phone" slot="icon"></up-icon>
            {{ salesManagerObj?.phoneNumber }}
          </div>
          <div *ngIf="salesManagerObj?.email" class="email">
            <up-icon name="email" slot="icon"></up-icon>
            <a href="#" (click)="openOutlook(salesManagerObj?.email, $event)">
              {{ salesManagerObj?.email }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
